export const hashDefaultString = '{{POST_BUILD_ENTERS_HASH_HERE}}';
export const defaultVersionCheckString = '{{POST_BUILD_ENTERS_HASH_HERE}}';
export const hashCheckDefaultInterval = 1000 * 60 * 15; // 15 minutes

export const uiV1 = 'ui-v1';
export const uiV2 = 'ui-v2';
